import React from 'react'
 import PhotoManager from '../Studio/PhotoManager'

function Photos() {
  return (
      <div className='w-full'>
        
              <PhotoManager /> 
      </div>
  )
}

export default Photos